import React from 'react';
import { Row, Col } from "react-bootstrap";
import { Link } from 'react-router-dom';
import Navigation from '../../routing/Navigation';
import './Footer.css';

const Footer = (props) => {

  if (props.loading) {
    return (<div>...loading...</div>)
  }
  else {
    return (
      <div className="Footer container">
        <Row>
          <Col sm={10} className="Footer__nav">

            {Navigation.map((navItem, index) => {
              return (
                <Link to={`/${navItem.category}/1`} key={navItem.id} className="Footer__nav__item">
                  {navItem.name.join(" ")}
                </Link>
              )
            })}

          </Col>
          <Col sm={2} className="Footer__copyright">
            <div className="jp-copyright">&copy; { new Date().getFullYear() } Julius Popa</div>
          </Col>
        </Row>
      </div>
    );

  }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js